import { useEffect, useState } from 'react'
import { ChevronUpIcon } from '@/shared/ui/icons/ChevronUpIcon'

const SHOW_AFTER_PX = 600

function useShownAfterScroll(): boolean {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    const sync = () => setShown(window.scrollY > SHOW_AFTER_PX)
    sync()
    window.addEventListener('scroll', sync, { passive: true })
    return () => window.removeEventListener('scroll', sync)
  }, [])

  return shown
}

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

export function ScrollTopButton() {
  const shown = useShownAfterScroll()
  if (!shown) return null

  return (
    <button
      type="button"
      aria-label="맨 위로"
      className="ui-pressable fixed right-8 bottom-7 z-40 flex h-[68px] w-[68px] cursor-pointer flex-col items-center justify-center rounded-[20px] border border-white-200 bg-white-50 px-3 py-2 text-white-900 shadow-[0_2px_8px_-2px_rgb(0_0_0/8%),0_4px_24px_-6px_rgb(0_0_0/16%)]"
      onClick={toTop}
    >
      <span className="flex items-center [&>svg]:h-6 [&>svg]:w-6" aria-hidden="true">
        <ChevronUpIcon />
      </span>
      <span className="text-body-lg leading-[1.4] font-medium">TOP</span>
    </button>
  )
}

export function ScrollTopButtonMobile() {
  const shown = useShownAfterScroll()
  if (!shown) return null

  return (
    <button
      type="button"
      aria-label="맨 위로"
      className="ui-pressable fixed right-[22px] bottom-[22px] z-40 flex h-[54px] w-[54px] cursor-pointer flex-col items-center justify-center rounded-[99px] border border-white-200 bg-white-50/70 px-3 pt-[5px] pb-2 text-black-100 shadow-[0_2px_8px_-2px_rgb(0_0_0/8%),0_4px_24px_-6px_rgb(0_0_0/16%)]"
      onClick={toTop}
    >
      <span className="flex items-center [&>svg]:h-5 [&>svg]:w-5" aria-hidden="true">
        <ChevronUpIcon />
      </span>
      <span className="text-label leading-[1.2] font-semibold">TOP</span>
    </button>
  )
}
